// Tracks whether a sign-out redirect is in flight, so the forced-login gates don't
// re-authenticate the user out from under it.
//
// Sign-out calls `logout({ openUrl: false })` to clear the auth0-spa-js cache (persisted in
// localStorage) before navigating to the hosted logout. That call also flips `isAuthenticated`
// to false in React state, which re-renders the gates in `custom-auth` / `cic-landing`. Those
// gates call `loginWithRedirect()` on !isAuthenticated, which navigates to Auth0 /authorize and
// CANCELS the pending hosted-logout navigation. The Auth0 SSO cookie is never cleared, so
// /authorize bounces straight back with a fresh code and the user is signed in again.
//
// This is deliberately a module-level flag rather than React or redux state: it must be readable
// SYNCHRONOUSLY during a render triggered by the Auth0 provider's own state update, with no
// batching or subscriber-ordering in play. By the time a redux update propagated, the gate would
// already have redirected.
//
// It is never reset — the only exit from a sign-out is a full-page navigation, which tears the
// module down anyway.

let loggingOut = false;

/** Mark a sign-out as in progress. Call this SYNCHRONOUSLY, first thing in the handler. */
export const beginLogout = (): void => {
	loggingOut = true;
};

/** True once sign-out has started; the gates must not call loginWithRedirect() while set. */
export const isLoggingOut = (): boolean => loggingOut;
